import React from 'react'
import { Tooltip } from '@material-ui/core'
import IconButton from '_/components/svg/icon-button'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

export function ExpandCollapseButton({ open, onToggle }) {
  return (
    <Tooltip title={open ? 'Retrair' : 'Expandir'} placement="top">
      <IconButton onClick={onToggle} onMouseDown={e => e.stopPropagation()} variant="ghost">
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    </Tooltip>
  )
}
